import { useContext } from "react"
import { ConfiguracaoFiscalContext } from "./ConfiguracaoFiscalContext"

export function useConfiguracaoFiscalContext() {
    return useContext(ConfiguracaoFiscalContext)
}
